import * as React from 'react';
import { CourseType, StatisticsFilters, StatusCode } from '../types';
import Input from 'src/components/FormElements/Input';
import DatePicker from 'src/components/DatePicker';
import Label from 'src/components/FormElements/Label';
import PeriodSelect from './PeriodSelect';
import ThemeSelect from './ThemeSelect';
import OrganizerSelect from './OrganizerSelect';
import StatusSelect from './StatusSelect';
import TypeSelect from './TypeSelect';

type FiltersProps = {
  className?: string;
  filters: StatisticsFilters;
  onChange: (filters: StatisticsFilters) => void;
};

const Filters = ({ className, filters, onChange }: FiltersProps) => {
  const handleFromDateChange = (from: Date | null) => {
    const { period } = filters;
    onChange({
      ...filters,
      period: { ...period, from },
    });
  };

  const handleToDateChange = (to: Date | null) => {
    const { period } = filters;
    onChange({
      ...filters,
      period: { ...period, to }
    });
  };

  const handlePeriodTypeChange = (type: StatisticsFilters['period']['type']) => {
    onChange({
      ...filters,
      period: { ...filters.period, type }
    });
  };

  const handleActivityNameQueryChange = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
    onChange({
      ...filters,
      activityNameQuery: target.value,
    });
  };

  const handleActivityNumberQueryChange = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
    const activityNumberQuery = target.value
      .replace(/\,+/, ' ')
      .replace(/\s+/, ' ')
      .trim()
      .split(' ');

    onChange({ ...filters, activityNumberQuery });
  };

  const handleThemesChange = (themes: number[]) => {
    onChange({ ...filters, themes });
  };

  const handleOrganizersChange = (organizers: number[]) => {
    onChange({ ...filters, organizers });
  };

  const handleTypeChange = (type: CourseType) => {
    onChange({ ...filters, type });
  };

  const handleStatusesChange = (statuses: StatusCode[]) => {
    onChange({ ...filters, statuses });
  };

  return (
    <div className={className}>
      <label className="block f4 font-semibold uppercase mb1" htmlFor="activityNumber">
        Basis- eller aktivitetsnummer
      </label>
      <Input
        elementSize="large"
        name="activityNumber"
        id="activityNumber"
        onChange={handleActivityNumberQueryChange}
      />
      <p className="f5 mt1 has-text-gray-700">Brug mellemrum eller komma (,) for at søge på flere aktivitetsnumre.</p>

      <label className="block f4 font-semibold uppercase mb1" htmlFor="activityName">Aktivitetsnavn</label>
      <Input
        elementSize="default"
        id="activityName"
        name="activityName"
        onChange={handleActivityNameQueryChange}
        value={filters.activityNameQuery}
        placeholder="Søg på hele eller dele af aktivitetsnavnet…"
      />

      <label className="block f4 font-semibold uppercase mt3 mb1" htmlFor="activityName">Kursustype</label>
      <TypeSelect value={filters.type} onChange={handleTypeChange} />

      <div className="f4 font-semibold uppercase mt3 mb1">
        {filters.type === 'advertisement' ? 'Oprettelsesperiode' : 'Periode'}
      </div>
      <PeriodSelect
        value={filters.period.type}
        onChange={handlePeriodTypeChange}
      />

      {filters.period.type === 'custom' && (
        <div className="mt2">
          <div>
            <Label htmlFor="fromDate">Startdato</Label>
            <DatePicker
              dateFormat="dd/MM/yyyy"
              placeholderText="Tryk for at vælge data"
              wrapperClassName="block w-full"
              onChange={handleFromDateChange}
              selected={filters.period.from}
              name="fromDate"
              id="fromDate"
              customInput={<Input />}
            />
          </div>
          <div className="mt1">
            <Label htmlFor="toDate">Slutdato</Label>
            <DatePicker
              dateFormat="dd/MM/yyyy"
              wrapperClassName="block w-full"
              placeholderText="Tryk for at vælge data"
              onChange={handleToDateChange}
              selected={filters.period.to}
              name="toDate"
              id="toDate"
              customInput={<Input />}
            />
          </div>
        </div>
      )}
      <label className="block f4 font-semibold uppercase mt3 mb1" htmlFor="activityName">Tema</label>
      <ThemeSelect value={filters.themes} onChange={handleThemesChange}/>

      <label className="block f4 font-semibold uppercase mt3 mb1" htmlFor="activityName">Arrangør</label>
      <OrganizerSelect value={filters.organizers} onChange={handleOrganizersChange} />

      {filters.type === 'default' && (
        <>
          <label className="block f4 font-semibold uppercase mt3 mb1" htmlFor="activityName">Status</label>
          <StatusSelect value={filters.statuses} onChange={handleStatusesChange} />
        </>
      )}
    </div>
  );
}

export default Filters;



// WEBPACK FOOTER //
// ./src/Pages/CoursePortal/Reports/components/Filters.tsx